import * as Yup from "yup";

const POSTCODE_VALIDATION = new RegExp(
  /^([A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/
);

export const addressValidationSchema = Yup.object().shape({
  postcode: Yup.string()
    .min(5, "The postcode should be at least 5 characters long")
    .max(8, "The postcode should be maximum 8 characters long")
    .matches(POSTCODE_VALIDATION, "The postcode entered is incorrect")
    .required("The postcode should not be empty"),
  address1: Yup.string().trim().required("Please enter your address"),
  address2: Yup.string().trim(),
  address3: Yup.string().trim().required("Please enter your city"),
  address4: Yup.string().trim(),
});

// Additional validation schema for finance applications
export const financeAddressValidationSchema = Yup.object().shape({
  postcode: Yup.string()
    .min(5, "The postcode should be at least 5 characters long")
    .max(8, "The postcode should be maximum 8 characters long")
    .matches(POSTCODE_VALIDATION, "The postcode entered is incorrect")
    .required("The postcode should not be empty"),
  buildingNumber: Yup.string().trim(),
  buildingName: Yup.string().trim(),
  flatNumber: Yup.string().trim(),
  street: Yup.string().trim().required("Please enter your street"),
  locality: Yup.string().trim(),
  townOrCity: Yup.string().trim().required("Please enter your town/city"),
  county: Yup.string().trim(),
});
